"use client";
import CustomDropdown from "@/components/ui/CustomDropdown";
import { usePathname, useRouter } from "@/i18n/routing";
import { useLocale, useTranslations } from "next-intl";
import { useSearchParams } from "next/navigation";

interface ILangSwitcherProps {
  disabled?: boolean;
  isBigArrow?: boolean;
  isCapitalize?: boolean;
  onChange?: (value: string) => void;
}

export default function LangSwitcher({
  disabled = false,
  isBigArrow,
  isCapitalize = false,
  onChange,
}: ILangSwitcherProps) {
  const t = useTranslations("LocaleSwitcher");
  const locale = useLocale();

  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const languageOptions = [
    {
      disabled: locale === "en",
      label: isCapitalize ? t("languageName", { code: "en" }) : t("languageName", { code: "en" }).toUpperCase(),
      value: "en",
    },
    {
      disabled: locale === "ru",
      label: isCapitalize ? t("languageName", { code: "ru" }) : t("languageName", { code: "ru" }).toUpperCase(),
      value: "ru",
    },
  ];

  const handleLanguageChange = (newLocale: string) => {
    if (newLocale === locale) {
      return;
    }

    if (onChange) {
      onChange(newLocale);
    }

    const queryString = searchParams.toString();
    const url = queryString ? `${pathname}?${queryString}` : pathname;

    router.replace(url, { locale: newLocale });
  };

  const currentOption = languageOptions.find((option) => option.value === locale);

  return (
    <CustomDropdown
      isBigArrow={isBigArrow}
      onChange={handleLanguageChange}
      options={languageOptions}
      readonly={disabled}
      value={currentOption?.label || locale}
    />
  );
}
